import React, { ComponentProps } from 'react'
import { BusinessCard } from './BusinessCard'
import { CertificateSectionCard } from './CertificateSectionCard'
import { DefaultCard } from './DefaultCard'
import { FeatureCard } from './FeatureCard'
import { ImageCard } from './ImageCard'
import { PreviewCard } from './PreviewCard'
import { StandardCard } from './StandardCard'
import { StatsCard } from './StatsCard'
import { TechnologyCard } from './TechnologyCard'
import { VideoCard } from './VideoCard'

// FIXME: only Card component will be exported  from here ( will do in separate branch as I have to replace all cards)
export { FeatureCard }
export { PreviewCard }
export { ImageCard }
export { TechnologyCard }
export { CertificateSectionCard }
export { BusinessCard }
export { VideoCard }
export { StandardCard }

export type { FeatureCardData } from './FeatureCard'
export type { ImageCardData } from './ImageCard'
export type { PreviewCardData } from './PreviewCard'
export type { StatsCardData, StatsCardProps } from './StatsCard'
export type { CardData } from './DefaultCard'
export type { TechnologyCardData } from './TechnologyCard'
export type { BusinessCardData } from './BusinessCard'
export type { VideoCardData } from './VideoCard'
export type { CertificateSectionCardData } from './CertificateSectionCard'
export type { StandardCardData } from './StandardCard'

const cardDefault = DefaultCard

type CardType = typeof cardDefault

export const cardMapping = {
  FeatureCard,
  ImageCard,
  PreviewCard,
  StatsCard,
  BusinessCard,
  VideoCard,
} satisfies Record<string, CardType>

type CardMappingType = typeof cardMapping

export type CardTypes = keyof CardMappingType

export type OwnProps<TType extends CardTypes> = { type?: TType }

export function Card<TType extends CardTypes>({
  type,
  ...rest
}: OwnProps<TType> & ComponentProps<CardMappingType[TType]>) {
  const DocType = type ? cardMapping[type] : cardDefault

  return <DocType {...rest} />
}
